import { ReactComponent as IconDarkFodler } from '@/assets/svgs/dark-folder.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from '@/context/toast/index.js'
import useEclips from '@/hooks/use-eclips/index'
import { useParams } from '@/lib/router-dom/index'
import rem from '@/utils/rem'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import CaseOwnerDropdown from './case-owner-dropdown.jsx'

export default function PackageOwnerModal({ visible, close, submit, currentOwner }) {
	const { eclipId } = useParams();
	const { addToastMessage } = useContext(ToastContext)
	const user = useSelector(state => state.auth.user)
	const [value, setValue] = React.useState('')
	const [error, setError] = React.useState('')
	const { packageOwnerUpdate, loading } = useEclips()
	const [checked, setChecked] = React.useState(false)

	const handleSubmit = async () => {
		if (!value?.email && !checked) {
		addToastMessage('Please select an owner', 'error')
		return
		}
		await packageOwnerUpdate(eclipId, checked ? user?.email : value?.email)
		close()
		submit()
	}

	const handleEmailChange = (selected) => {
		let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
		setError(
			regex.test(selected?.email)
			? ''
			: 'Please enter Valid Email',
		)
		setValue(selected)
	}

	const handleAddSelf = () => {
		setChecked(!checked)
		if (checked) {
			setValue('')
			setError('')
		}
	}


	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDarkFodler />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Change Package Owner
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-receipient__input">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								Current Owner
							</span>
							<input
								type="text"
								value={currentOwner}
								disabled
							/>
						</div>
						<div className="eclip-receipient__input">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								New Owner
							</span>
							{checked ?
								<input type="text" value={user?.email} disabled />
								: <CaseOwnerDropdown value={value} setValue={handleEmailChange} style={{
								width: '100%',
								}} />}
							{error && value !== '' && (
								<span className="error error-text">{error}</span>
							)}
						</div>
						<div className="eclip-receipient__input checkbox" onClick={handleAddSelf}>
							<input type="checkbox" name="assign" checked={checked} />
							<span>Add Self as owner</span>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Confirm"
							loading={loading}
							disabled={loading || error !== ''}
							submit={handleSubmit}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
